import { Div } from 'ui'
import Text from 'ui/Text'
import React from 'react'
import { useTheme } from 'styled-components'
import { ReactComponent as InfoSVG } from 'assets/icons/info.svg'
import { ReactComponent as CheckSVG } from 'assets/icons/check.svg'


const FormRequirement = ({ isCompleted, description }) => {

  const theme = useTheme()

  return (
    <Div display='flex' gap={8} marginTop={12} marginBottom={12}>
      <Div
        background={isCompleted
          ? theme.colors.secondary.green[900]
          : theme.colors.neutral[800]
        }
        color={isCompleted
          ? theme.colors.secondary.green[400]
          : theme.text.default
        }
        height={20}
        minWidth={20}
        borderRadius={100}
        display='grid'
        placeItems='center'
      >
        {isCompleted
          ? <CheckSVG height={14} width={14} />
          : <InfoSVG height={14} width={14} />
        }
      </Div>

      <Text size='sm' color={isCompleted ? 'highlight' : 'default'}>
        {description}
      </Text>
    </Div>
  )
}

export default FormRequirement